import { IRoute } from '../types/route';
import Login from '../component/page/authPage/Login';

const publicRoutes: IRoute[] = [{ path: '/login', element: <Login /> }];

export default publicRoutes;
